<template>
	<div class="childDiv2" id="page11" ref="mainEl" page="5">
		<div class="childWrapper">
			<img alt="" src="images/1x_images/section2/page5/text-result.png" srcset="images/2x_images/section2/page5/text-result.png 2x" class="relative top-[210px] left-[90px]" />
			<img alt="" src="images/1x_images/section2/page5/text-result-bottom.png" srcset="images/2x_images/section2/page5/text-result-bottom.png 2x" class="absolute bottom-[70px] left-[90px]" />
			<div class="relative center top-[250px] w-fit">
				<img alt="" src="images/1x_images/section2/page5/serum-result.png" srcset="images/2x_images/section2/page5/serum-result.png 2x" />
				<img alt="" src="images/1x_images/section2/page5/serum-result-gold.png" srcset="images/2x_images/section2/page5/serum-result-gold.png 2x" class="absolute top-0" ref="goldEl" />
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	name: "page-1",
	data() {
		return {
			tween: null,
		};
	},
	methods: {
		start() {
			this.animateGold();
		},
		stop() {
			if (this.tween) this.tween.kill();
			gsap.set(this.$refs.goldEl, { y: 0, overwrite: true });
		},
		animateGold() {
			this.tween = gsap.to(this.$refs.goldEl, { force3D: true, y: 30, duration: 2, ease: "sine.inOut", repeat: -1, yoyo: true });
		},
	},
	mounted() {},
};
</script>

<style></style>
